var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ DeleteLabel: _vm.deleteLabel },on:{"click":_vm.handleDelete}},[_c('img',{attrs:{"src":"/static/images/measureActive.png","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }